module.exports = __webpack_public_path__ + "img/livro1.84616032.jpg";